/**
 * Same publishable key as the buyer mobile apps (iOS BuyDrop.debug.xcconfig / Android local.properties).
 * Safe to embed in the web client — publishable keys are not secret.
 */
export const BUYDROP_STRIPE_PUBLISHABLE_KEY =
  'pk_live_51Sa4MALRbD0CMYQ9nPT2LYMhgV2OErRP7w2kre4i4xJrq7tImCJGeslNNz7vC8MWy4CNM538aIrwI3SVW8cWTWf600c4W6Yv1u';
